// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import amendmentDecisionEntity from './entities/amendment-decision.json';
import amendmentDecisionMenu from '../pages/amendment-decision/menu.json';
import amendmentDecisionFullForm from '../pages/amendment-decision/forms/full.json';
import amendmentDecisionContextForm from '../pages/amendment-decision/forms/context.json';
import amendmentDecisionMiniForm from '../pages/amendment-decision/forms/mini.json';
import amendmentDecisionLookupForm from '../pages/amendment-decision/forms/lookup.json';
import amendmentDecisionTableView from '../pages/amendment-decision/views/table.json';
import amendmentDecisionCardsView from '../pages/amendment-decision/views/cards.json';
import amendmentDecisionDashboardView from '../pages/amendment-decision/views/dashboard.json';

/** Тип запису «Рішення» зі сторінками пакета: меню, форми та подання з pages/amendment-decision/. */
export const amendmentDecisionDefinition: IRecordTypeDefinition = {
  ...amendmentDecisionEntity,
  views: assembleViewSet({
      table: amendmentDecisionTableView,
      cards: amendmentDecisionCardsView,
      dashboard: amendmentDecisionDashboardView,
  }),
  form: amendmentDecisionFullForm,
  forms: { full: amendmentDecisionFullForm, context: amendmentDecisionContextForm, mini: amendmentDecisionMiniForm, lookup: amendmentDecisionLookupForm },
  menu: amendmentDecisionMenu,
} as IRecordTypeDefinition;
